import { render, staticRenderFns } from "./STableSalesCashRegisterComp.vue?vue&type=template&id=20300186&"
import script from "./STableSalesCashRegisterComp.vue?vue&type=script&lang=js&"
export * from "./STableSalesCashRegisterComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports